import React, { createContext, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';

const canDeactivateDiscount = ({ isEditMode, canDisableSilverVouchers }) => isEditMode && canDisableSilverVouchers;
const canActivateDiscount = ({ isEditMode, canEnableSilverVouchers }) => isEditMode && canEnableSilverVouchers;

const discountSettings = {
  status: {
    ACTIVE: canDeactivateDiscount,
    INACTIVE: canActivateDiscount,
    EXPIRED: () => false,
    REDEEMED: () => false
  }
};

export const DiscountEditSettingsContext = createContext();

export const DiscountEditSettings = ({
  children,
  voucherType,
  voucherStatus,
  isEditMode,
  canDisableSilverVouchers,
  canEnableSilverVouchers,
  canEditDiscounts
}) => {
  const editSettings = useMemo(() => {
    const options = {
      voucherType,
      voucherStatus,
      isEditMode,
      canEnableSilverVouchers,
      canDisableSilverVouchers,
      canEditDiscounts
    };

    const fieldSettings = Object.keys(discountSettings).reduce(
      (acc, key) => ({
        ...acc,
        [key]: !!discountSettings[key][voucherStatus](options)
      }),
      {}
    );

    const formSettings = { isDiscountEditable: canEditDiscounts };
    return { fields: fieldSettings, form: formSettings };
  }, [voucherType, voucherStatus, isEditMode, canEditDiscounts, canDisableSilverVouchers, canEnableSilverVouchers]);

  return <DiscountEditSettingsContext.Provider value={editSettings}>{children}</DiscountEditSettingsContext.Provider>;
};

export const useDiscountEditSettings = () => {
  const editSettings = useContext(DiscountEditSettingsContext);

  return {
    fields: editSettings.fields,
    form: editSettings.form
  };
};

DiscountEditSettings.propTypes = {
  voucherType: PropTypes.string.isRequired,
  voucherStatus: PropTypes.string.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  canEditDiscounts: PropTypes.bool.isRequired,
  canEnableSilverVouchers: PropTypes.bool.isRequired,
  canDisableSilverVouchers: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};
